import { render, staticRenderFns } from "./AppContentKBEdit.vue?vue&type=template&id=433bc66d&scoped=true&"
import script from "./AppContentKBEdit.vue?vue&type=script&lang=js&"
export * from "./AppContentKBEdit.vue?vue&type=script&lang=js&"
import style0 from "./AppContentKBEdit.vue?vue&type=style&index=0&id=433bc66d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433bc66d",
  null
  
)

export default component.exports